import { render, staticRenderFns } from "./MtrlList.vue?vue&type=template&id=6c192916&scoped=true&"
import script from "./MtrlList.vue?vue&type=script&lang=js&"
export * from "./MtrlList.vue?vue&type=script&lang=js&"
import style0 from "./MtrlList.vue?vue&type=style&index=0&id=6c192916&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c192916",
  null
  
)

export default component.exports